import z from 'zod'

import { entitySchema } from '@/utility'

export const scalarAdminSchema = entitySchema
  .extend({
    email: z.string().email(),
    name: z.string().min(2).max(100),
    role: z.enum(['admin', 'super-admin']),
  })
  .meta({ id: 'scalar-admin' })

export type ScalarAdmin = z.infer<typeof scalarAdminSchema>
